import React from "react";
import { connect } from "react-redux";

import { fetchDomains, setActiveDomain, showModal } from "actions";
import Table, { choiceCell } from "components/table";
import { FaEdit, FaTrash } from "react-icons/fa";
import IconLink from "components/IconLink";
import { DELETE_DOMAIN_MODAL, DOMAIN_MODAL } from "components/modals";
import { loadingSelector, domainsSelector } from "../../../reducers";
import { DOMAIN_TYPES } from "./DomainForm";
import { DOMAIN_ACCOUNT_TYPES_MAP } from "./constants";

const DomainsTable = ({ ...props }) => {
  React.useEffect(() => {
    props.fetchDomains();
  }, []);
  const columns = [
    {
      Header: "Action",
      className: "action",
      Cell: ({ row }) => {
        return (
          <>
            <IconLink
              Icon={FaEdit}
              iconConfig={{ className: "table--action-icon" }}
              tooltip="View/Edit"
              onClick={() => {
                props.setActiveDomain(row.original.id);
                props.showModal(DOMAIN_MODAL);
              }}
            />
            <IconLink
              Icon={FaTrash}
              iconConfig={{ className: "table--action-icon btn--red" }}
              tooltip="Delete"
              onClick={() => {
                props.showModal(DELETE_DOMAIN_MODAL, {
                  id: row.original.id,
                });
              }}
            />
          </>
        );
      },
    },
    {
      Header: "Company Name",
      accessor: "company_name",
    },
    {
      Header: "URL",
      accessor: "url",
    },
    {
      Header: "Type",
      accesor: "type",
      Cell: ({ row }) => {
        if (row.original.type === 1) {
          return "Protected";
        } else if (row.original.type === 2) {
          return "Common";
        } else {
          return "";
        }
      },
    },
    {
      Header: "Account Type",
      accessor: "account_type",
      Cell: ({ row }) => {
        let accountTypes = row.original.account_type;
        let accountTypesFormatted = [];
        if (accountTypes) {
          accountTypes = accountTypes.split(",");
          for (const a of accountTypes) {
            let name = DOMAIN_ACCOUNT_TYPES_MAP[a];
            if (name) {
              accountTypesFormatted.push(name);
            }
          }
        }
        return accountTypesFormatted.join(", ");
      },
    },
    {
      Header: "Sales Representative",
      accessor: "sales_representative_name",
    },
  ];

  let tableClass = "";
  if (props.domains.length > 1) {
    tableClass = "tableFixed";
  }

  return (
    <Table
      columns={columns}
      data={props.domains}
      defaultSort={true}
      paginated={false}
      emptyMessage={props.loading.domain ? `Loading Domains...` : `No Domains found`}
      initialPageSize={100}
      tableClass={tableClass}
    />
  );
};

const mapStateToProps = state => {
  return {
    domains: domainsSelector(state),
    loading: loadingSelector(state),
  };
};

export default connect(mapStateToProps, {
  showModal,
  setActiveDomain,
  fetchDomains,
})(DomainsTable);
